import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import CallListingShape from 'app/shapes/CallListingShape';

import {
  Grid,
  Stack,
  Typography,
} from '@mui/material';

import {
  toNumber,
  toCurrency,
} from 'app/helpers/currencyHelpers';

import ModalsContext from 'app/contexts/ModalsContext';
import useCreditCardManagement from 'app/hooks/useCreditCardManagement';
import { userHasCard } from 'app/helpers/userHelper';

import InsuffientFundsError from 'app/components/call/errors/InsufficientFundsError';

const CurrentBalance = ({
  balance,
  listing,
  isBalanceLoading,
  isListingLoading,
  currentUser,
}) => {
  const availableBalance = !isBalanceLoading && toNumber(balance.available_balance);
  const currentUserHasCard = userHasCard(currentUser);
  const { openModal, closeModal } = useContext(ModalsContext);
  const onTryAgainSuccess = closeModal;
  const onManageCardsSuccess = closeModal;
  const onAddToBalanceSuccess = closeModal;

  const {
    handleAddToBalanceOrManageCards,
  } = useCreditCardManagement({
    openModal,
    currentUser,
    guard: null,
    setGuard: null,
    onTryAgainSuccess,
    onManageCardsSuccess,
    onAddToBalanceSuccess,
  });

  const resolveMoneyManagementFlow = (event) => {
    event.preventDefault();

    closeModal();

    handleAddToBalanceOrManageCards({
      currentUserHasCard,
      options: {
        showError: false,
      },
    });
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        maxWidth: 550,
        // margin: 'auto',
        alignItems: 'flex-start', // Align items to the top
      }}
    >
      <Grid
        item
        xs={3}
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Typography
          variant="body1"
          fontWeight="bold"
          style={{ textAlign: 'right' }}
        >
          Balance
        </Typography>
      </Grid>
      <Grid
        item
        xs={9}
      >
        { isBalanceLoading || isListingLoading ? '-' : (
          <>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ maxWidth: '300px' }}
            >
              <Typography variant="body1" id="call-current-balance">
                {toCurrency(availableBalance)}
              </Typography>
              <Typography
                variant="body2"
                sx={{ px: 1 }}
              >
                <a
                  id={currentUserHasCard ? 'call-now-add-balance-link' : 'call-now-card-required'}
                  data-version="redesign"
                  onClick={resolveMoneyManagementFlow}
                  href="#"
                >
                  Add
                </a>
              </Typography>
            </Stack>
            <InsuffientFundsError
              balance={balance}
              listing={listing}
              isLoading={isListingLoading}
              currentUser={currentUser}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
};

CurrentBalance.defaultProps = {
  balance: null,
  listing: null,
};

CurrentBalance.propTypes = {
  balance: PropTypes.object,
  listing: CallListingShape,
  isBalanceLoading: PropTypes.bool.isRequired,
  isListingLoading: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default CurrentBalance;
